import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { FINISH_SECTION } from "queries/mutations";
import { Viewer, Worker, SpecialZoomLevel, ZoomEvent } from '@react-pdf-viewer/core';
import useMakeScrollable from 'custom_hooks/make-scrollable';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PlayLectionPdf = ({ setHeaderTitle }) => {
  useMakeScrollable()
  const location = useLocation();
  let history = useHistory();
  const { pdfUrl, name, id, courseId } = location.state || {};

  useEffect(() => {
    if (name) {
      setHeaderTitle(name);
    }
  }, [name, setHeaderTitle]);

  const [finishSection] = useMutation(FINISH_SECTION, {
    onCompleted({ finishSection }) {
      if (finishSection.userHistory) {
        history.push(`/lections/success/${id}`);
      } else {
        history.push(`/courses/${courseId}`);
      }
    },
  });

  const handleFinish = () => {
    const userId = localStorage.getItem("user_id");
    finishSection({
      variables: { userId: userId, sectionId: id },
    });
  };

  const handleZoom = (e: ZoomEvent) => {
    console.log(`Zoom to ${e.scale}`);
  };

  return (
    <div className="lection-pdf scrollable">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <div style={{ width: "100%" }}>
          <Viewer
            fileUrl={pdfUrl}
            defaultScale={SpecialZoomLevel.PageWidth}
            onZoom={handleZoom}
          />
        </div>
      </Worker>
      <button 
        className='lection-pdf-button'
        onClick={handleFinish}
      >
        Abschließen
      </button>
    </div>
  )
}

export default PlayLectionPdf;